import { baseApi } from '../../api/baseApi'

export const salahApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSalahs: builder.query({
      query: (spaceId) => ({
        service: 'events',
        url: `/salahV1/private/findAll/${spaceId}`,
      }),
      providesTags: (result, error, spaceId) => [
        { type: 'Salah', id: 'LIST' },
        { type: 'Salah', id: spaceId },
      ],
      transformResponse: (response) => response,
      keepUnusedDataFor: 180,
    }),

    createSalah: builder.mutation({
      query: (salahData) => ({
        service: 'events',
        url: '/salahV1/private/create',
        method: 'POST',
        body: salahData,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'Salah', id: 'LIST' },
        { type: 'Salah', id: arg.spaceId },
      ],
      transformResponse: (response) => response,
    }),
    updateSalah: builder.mutation({
      query: ({ salahData, id }) => ({
        service: 'events',
        url: `/salahV1/private/update/${id}`,
        method: 'PATCH',
        body: salahData,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'Salah', id: 'LIST' },
        { type: 'Salah', id: arg.salahData.spaceId },
      ],
      transformResponse: (response) => response,
    }),

    deleteSalah: builder.mutation({
      query: (salahId) => ({
        service: 'events',
        url: `/salahV1/private/delete/${salahId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, salahId) => [
        { type: 'Salah', id: 'LIST' },
        { type: 'Salah', id: salahId },
      ],
      transformResponse: (response) => response,
    }),

    getSalahSettings: builder.query({
      query: (salahId) => ({
        service: 'events',
        url: `/salahV1/private/settings/${salahId}`,
      }),
      providesTags: (result, error, salahId) => [
        { type: 'SalahSettings', id: salahId },
      ],
      transformResponse: (response) => response,
      keepUnusedDataFor: 60,
    }),

    upsertSalahSettings: builder.mutation({
      query: (settingsData) => ({
        service: 'events',
        url: '/salahV1/private/settings/upsert',
        method: 'POST',
        body: settingsData,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'SalahSettings', id: arg.salahId || arg.id },
      ],
      transformResponse: (response) => response,
    }),

    getWaqt: builder.mutation({
      query: (salahData) => ({
        service: 'events',
        url: '/salahV1/private/getWaqt',
        method: 'POST',
        body: salahData,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'Salah', id: 'LIST' },
        { type: 'Salah', id: arg.spaceId },
      ],
      transformResponse: (response) => response,
    }),
    getSalahTime: builder.query({
      query: ({ spaceId, date }) => ({
        service: 'events',
        url: `/salahV1/public/daily/space/${spaceId}/${date}`,
      }),

      transformResponse: (response) => response,
      keepUnusedDataFor: 60,
    }),

    shareImage: builder.mutation({
      query: (salahData) => ({
        service: 'events',
        url: `/share-salah/image`,
        method: 'POST',
        body: salahData,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'ShareSalah', id: 'LIST' },
      ],
      transformResponse: (response) => response,
    }),

    getEmbedCode: builder.mutation({
      query: (salahData) => ({
        service: 'events',
        url: `/share-salah/upsert`,
        method: 'POST',
        body: salahData,
      }),

      transformResponse: (response) => response,
    }),
    regenerateSalahData: builder.mutation({
      query: (salahData) => ({
        service: 'events',
        url: `/schedular/regenerate-salah-data`,
        method: 'POST',
        body: salahData,
      }),

      transformResponse: (response) => response,
    }),
    getSalahMontlyData: builder.query({
      query: ({ spaceId, year, month }) => ({
        service: 'events',
        url: `/salahV1/public/daily/monthly/${spaceId}/${year}/${month}`,
      }),
      providesTags: (result, error, spaceId) => [
        { type: 'Salah', id: 'LIST' },
        { type: 'Salah', id: spaceId },
      ],
      transformResponse: (response) => response,
      keepUnusedDataFor: 60,
    }),
    getShareSalahEmbededCodeBySpaceId: builder.query({
      query: (spaceId) => ({
        service: 'events',
        url: `/share-salah/getShareSalahBySpaceId/${spaceId}`,
      }),

      transformResponse: (response) => response,
      keepUnusedDataFor: 180,
    }),

    upsertShareSalahImage: builder.mutation({
      query: (salahData) => ({
        service: 'events',
        url: `/share-salah/private/upsertImage`,
        method: 'POST',
        body: salahData,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'ShareSalahImage', id: 'LIST' },
      ],
      transformResponse: (response) => response,
    }),

    getShareSalahImageBySpaceId: builder.query({
      query: (spaceId) => ({
        service: 'events',
        url: `/share-salah/private/getShareSalahImageBySpaceId/${spaceId}`,
      }),
      providesTags: (result, error, spaceId) => [
        { type: 'ShareSalahImage', id: spaceId },
      ],
      transformResponse: (response) => response,
      keepUnusedDataFor: 180,
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetSalahsQuery,
  useCreateSalahMutation,
  useUpdateSalahMutation,
  useDeleteSalahMutation,
  useGetSalahSettingsQuery,
  useUpsertSalahSettingsMutation,
  useGetWaqtMutation,
  useGetSalahTimeQuery,
  useLazyGetSalahTimeQuery,
  useShareImageMutation,
  useGetEmbedCodeMutation,
  useGetSalahMontlyDataQuery,
  useLazyGetSalahMontlyDataQuery,
  useRegenerateSalahDataMutation,
  useGetShareSalahEmbededCodeBySpaceIdQuery,
  useLazyGetShareSalahEmbededCodeBySpaceIdQuery,
  useUpsertShareSalahImageMutation,
  useGetShareSalahImageBySpaceIdQuery,
  useLazyGetShareSalahImageBySpaceIdQuery,
} = salahApi
